const DisableButton = (items) => {
  for (let i = 0; i < items.length; i++) {
    if(items[i].quantity.length === 0 || items[i].quantity % items[i].minStock !== 0){
      return true;
    }
  }
  return false;
}
export default DisableButton;